import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

const PopupLockContext = createContext();

export function PopupLockProvider({ children }) {
  // 🔥 all popup states in one place
  const [locks, setLocks] = useState({
    login: false,
    location: false,
    cart: false,
    call: false,
  });

  // 🔑 set specific popup lock - Memoize karo
  const setLock = useCallback((key, value) => {
    setLocks((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []); // ✅ Empty dependency array

  // ✅ FIXED: useCallback se wrap karo
  const openLock = useCallback((key) => {
    setLock(key, true);
  }, [setLock]); // ✅ setLock par depend karo

  // ✅ FIXED: useCallback se wrap karo
  const closeLock = useCallback((key) => {
    setLock(key, false);
  }, [setLock]); // ✅ setLock par depend karo

  // 🔥 check if ANY popup is open
  const isAnyPopupOpen = useMemo(() => {
    return Object.values(locks).some(Boolean);
  }, [locks]);

  // 🔥 close all popups at once (bonus)
  const resetLocks = useCallback(() => {
    setLocks({
      login: false,
      location: false,
      cart: false,
      call: false,
    });
  }, []); // ✅ Empty dependency array

  return (
    <PopupLockContext.Provider
      value={{
        locks,
        setLock,
        openLock,
        closeLock,
        isAnyPopupOpen,
        resetLocks,
      }}
    >
      {children}
    </PopupLockContext.Provider>
  );
}

// 🔥 custom hook
export const usePopupLock = () => {
  const context = useContext(PopupLockContext);
  if (!context) {
    throw new Error("usePopupLock must be used within PopupLockProvider");
  }
  return context;
};